import { DRFListResponseWrapper, getGlobalHeadersAsObject } from "..";

const API_PATH = "/api/v2/cooldown/";

export type Cooldown = {
	id?: number;
	until: string;
	created?: string;
	updated?: string;
	person: number;
	user: number;
	user_name?: string;
	user_first_name?: string;
	user_email?: string;
};

export const setCooldown = (data: Cooldown): Promise<Cooldown> => {
	return fetch(API_PATH, {
		method: "POST",
		headers: {
			...getGlobalHeadersAsObject(),
			"Content-Type": "application/json",
		},
		body: JSON.stringify(data),
	}).then((res) => res.json());
};

export const getCooldowns = ({
	person,
	limit,
	offset,
	hideHistory = true,
}: {
	person?: number;
	limit?: number;
	offset?: number;
	hideHistory?: boolean;
}): Promise<DRFListResponseWrapper<Cooldown[]>> => {
	const params = new URLSearchParams();
	if (person) params.append("person", person.toString());
	if (limit) params.append("limit", limit.toString());
	if (offset) params.append("offset", offset.toString());
	if (hideHistory) {
		params.append("until__gte", new Date().toISOString());
	}

	return fetch(`${API_PATH}?${params.toString()}`, {
		method: "GET",
		headers: { ...getGlobalHeadersAsObject() },
	}).then((res) => res.json());
};

export const deleteCooldown = ({
	cooldownId,
}: {
	cooldownId: number;
}): Promise<Response> => {
	return fetch(`${API_PATH}${cooldownId}/`, {
		method: "DELETE",
		headers: { ...getGlobalHeadersAsObject() },
	});
};

export const patchCooldown = ({
	cooldownId,
	until,
	person,
	user,
}: {
	cooldownId: number;
	until: string;
	person: number;
	user: number;
}): Promise<Cooldown> => {
	const data: Cooldown = {
		until: until,
		person: person,
		user: user,
	};
	return fetch(`${API_PATH}${cooldownId}/`, {
		method: "PATCH",
		headers: { ...getGlobalHeadersAsObject(), "Content-Type": "application/json" },
		body: JSON.stringify(data),
	}).then((res) => res.json());
};
